import { render, staticRenderFns } from "./transaction-summary-related.vue?vue&type=template&id=bca03a3a&"
import script from "./transaction-summary-related.vue?vue&type=script&lang=js&"
export * from "./transaction-summary-related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports